import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ResponsableModel } from '../../responsable/models/responsable.model';
import { EleveModel } from '../../../eleve/models/eleve.model';
import { TabsService } from '../../services/tabs.service';
import { DateHelper } from '../../helpers/date.helper';
import { SettingsService } from '../../../core/settings/settings.service';
import { ExportService } from '../../services/export.service';
import { FamilleModel } from '../models/famille.model';
import { environment } from '../../../../environments/environment';
import { FamilleActions } from '../models/famille.store';
import { StoreService, TableEvent } from '@ngx-resource-toolkit/core';
import { ToasterService } from 'angular2-toaster';
import { FactureModel } from '../../facture/models/facture.model';

@Component({
    selector: 'info-famille',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss']
})
export class InfoFamilleComponent implements OnInit {

    @Input() public famille: any;
    @Output() public deleteFamille = new EventEmitter();

    @Input() public hideActions: boolean = false;

    public responsableModel: ResponsableModel;
    public eleveModel: EleveModel;
    private DateHelper = DateHelper;
    public isLienFamilleAffiche: boolean = false;

    constructor(private router: Router,
        private http: HttpClient,
        private tabsService: TabsService,
        private settings: SettingsService,
        private store: StoreService,
        private exportService: ExportService,
        private toaster: ToasterService,)
    {
        this.responsableModel = new ResponsableModel({});
        this.eleveModel = new EleveModel({});
    }

    ngOnInit() {
        const fonctionnaliteLienFamille = 'LIEN_FAMILLE';
        this.isLienFamilleAffiche = this.settings.isUserMenuAllowed(fonctionnaliteLienFamille);
    }
    portailFamille() {
        const idFamille = this.famille && this.famille.id ? this.famille.id : null;
        this.router.navigate(['/administration/acces_famille', idFamille]); //, idFamille
    }
    mailto(value) {
        if (!value) {
            return '';
        }
        return '<a [href]="mailto:' + value + '">' + value + '</a>';
    }
    sendEmail() {
        const id = this.famille.id;
        this.router.navigate(['courriel/tofamille', id]);
    }
    onRefresh(data: TableEvent) {
        const id = this.famille.id;
        this.clearCacheFamille(id);
        this.router.navigate(['/famille/']);
        this.router.navigate(['/famille/show', id ]);

        this.tabsService.addTab({
            label: `${this.famille.nom} (${this.famille.id})`,
            link: '/famille/show/' + this.famille.id,
            group: 'famille',
            iconClass: 'fa fa-user',
        });
    }

    clearCacheFamille(id) {
        console.log('clearCacheFamille',id);
        //Vidage cache pour forcer rechargement
        this.store.dispatch(
            FamilleActions.clear({
                id: id,
                errorCallback: (err) => {
                    console.log('FamilleSearchComponent', 'clear error', err);
                    this.toaster.pop('error', 'Erreur lors du vidage de la famille');
                }
            })
        );
    }

    creerEleve() {
        this.router.navigate(['/eleve/create', this.famille.id, this.famille.nom]);
    }
    editFamille() {
        this.tabsService.addTab({
            label: `${this.famille.nom} (${this.famille.id})`,
            link: '/famille/edit/' + this.famille.id,
            group: 'famille',
            iconClass: 'fa fa-edit',
        });
        this.router.navigate(['/famille/edit', this.famille.id]);
    }
    imprimeFicheFamille() {
        const params = [this.famille.id, this.settings.getUserSetting('anneeScolaire')];
        const method = 'printFicheFamille';
        const fileNameOnDisk = 'Famille_' + this.famille.id;
        const familleModel = new FamilleModel(this.famille);
        this.exportService.generePDF(familleModel, params, method, fileNameOnDisk);
    }
    imprimeConfirmationInscription() {
        console.log('printConfirmationInscription');
        const service = 'impression';
        const method = 'printConfirmationInscription';
        const params = [this.famille.id, this.settings.getUserSetting('anneeScolaire')];
        const fileNameOnDisk = 'Famille_' + this.famille.id;
        this.exportService.generePDF2(service, method, params, fileNameOnDisk);
    }
    onEleveConsult(event) {
        const id = event.row.id;
        this.tabsService.addTab({
            label: `${event.row.nom} (${id})`,
            link: '/eleve/show/' + id,
            group: 'eleve',
            iconClass: 'fa fa-user',
        });
        this.router.navigate(['/eleve/show', id]);
    }

}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/famille/info/info.component.ts